export const EntidadeTypes = {
  SET_ENTIDADE: 'SET_ENTIDADE',
  SET_ENTIDADE_PRINCIPAL: 'SET_ENTIDADE_PRINCIPAL',
  CLEAR_ENTIDADE: 'CLEAR_ENTIDADE'
};
